export const MAX_CAROUSEL_ITEMS = 12;
